/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '@/_helpers/roots';

let paymentStatusForApiUrl = root.paymentStatusForApiUrl.link;
let doctorConsultFeesApiUrl = root.doctorConsultFeesApiUrl.link;
let getPaymentHistoryApiURL = root.getPaymentHistoryApiUrl.link;
let getAppointmentIdApiUrl = root.getAppointmentIdApiUrl.link;
let paypalWebhookApiUrl = root.paypalWebhookApiUrl.link;

export default {
  state: {
    getPaymentHistoryState:{},
  },
  mutations: {
    getPaymentHistoryMutation(state, value) {
      Vue.set(state, 'getPaymentHistoryState', value);
    },
  },
  actions: {
    // paypal Webhook Function
    paypalWebhook(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(paypalWebhookApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Get Appointment Id From Transaction Func
    getAppointmentIdFromTransactionFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(getAppointmentIdApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Get Payment History Function
    getPaymentHistoryFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(getPaymentHistoryApiURL).then(response => {
            context.commit('getPaymentHistoryMutation', response);
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Doctor Consult Fees Function
    doctorConsultFeesFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(doctorConsultFeesApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
    // Payment Status For Post Function
    paymentStatusForPostFunc(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(paymentStatusForApiUrl, payload).then(response => {
            resolve(response);
          }).catch(err => {
            reject(err);
          })
        })
    },
  },
  getters: {
    getPaymentHistoryGetters : state => state.getPaymentHistoryState,
  }
}